import * as React from 'react';

export const ApprovalLongTextField: React.StatelessComponent<any> = (props: any) => (
    <div className='text-display' style={{border: props.textChanged ? '1px solid black' : ''}}>
        {props.iconClassName ? 
            <div className='text-display-icon-container'>
                <i className={props.iconClassName} />
            </div> : 
            <> </>
        }
        <p style={{whiteSpace: "pre-wrap"}}>
                {props.children}
        </p>
    </div>
);



// WEBPACK FOOTER //
// ./src/views/ApprovalView/ApprovalLongTextField.tsx